export default __webpack_public_path__ + "static/media/our vision image 2.6fe0e5aa.jpg";